import '@/store/api/product-inventory/typedefs'
import api from '@/store/api/product-inventory'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    supplier: {}
})

const state = initialState()

export default {
    namespaced: true,
    state,
    getters: {
        supplier: state => state.supplier
    },
    actions: {
        /**
         * @param {ProductQuery} data
         * @returns {Promise<*>}
         */
        showSupplier: async ({commit, dispatch}, data) => {
            try {
                const response = await api.suppliers.showSupplier(data)
                commit(mutationTypes.SET_SUPPLIER, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {Supplier} data
         * @returns {Promise<*>}
         */
        createSupplier: async ({dispatch}, data) => {
            try {
                return await api.suppliers.createSupplier(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {Supplier} data
         * @returns {Promise<*>}
         */
        updateSupplier: async ({dispatch}, data) => {
            try {
                return await api.suppliers.updateSupplier(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {Supplier} data
         * @returns {Promise<*>}
         */
        removeSupplier: async ({dispatch}, data) => {
            try {
                return await api.suppliers.removeSupplier(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetSupplier: async ({commit}) => commit(mutationTypes.RESET_SUPPLIER)
    },
    mutations: {
        [mutationTypes.SET_SUPPLIER]: (state, data) => state.supplier = data,
        [mutationTypes.RESET_SUPPLIER]: (state) => Object.assign(state, initialState())
    }
}
